import React from 'react';

type VideoFeedProps = {
  src: string;
}

export const VideoFeed: React.FC<VideoFeedProps> = ({ src }) => {
  return (
    <img
      className="iframe"
      src={src}
      alt=""
    >
    </img>
    // <iframe
    //   className="iframe"
    //   src={src}
    //   title="YouTube video player" frameBorder="0" 
    //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;" ></iframe>
  );
};
